﻿import {ResidencyResult} from "../types/ResidencyResult";
import {unitToString} from "./unitToString";

export function residencyToCompactString(residency: ResidencyResult): string {
	const address = residency.address;
	const segments: string[] = [];

	if (address.streetNumber) segments.push(address.streetNumber);
	if (address.street) segments.push(address.street);

	if (address.unit) {
		segments.push(`, ${unitToString(address.unit)}`);
	}

	if (residency.suffix) {
		segments.push(`[${residency.suffix}]`);
	}

	return segments.join(" ");
}
